export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/814ac9faa2ce24eb8e96f2a96cc4106e.jpg";